import { IAuthenticationDTO, IAuthenticationServerResponse } from "./IAuthService";

export const parseAuthenticationServerResponseToAuthentication = (
    response: IAuthenticationServerResponse,
  ): IAuthenticationDTO => {
    if (!response) {
      throw new Error('Missing authentication server response');
    }
  
    return {
      id: response.usuarioMeepPOSId,
      name: response.usuarioMeepPOSApelido,
      local: {
        id: response.localId,
        name: response.localNome,
        imageUrl: response.localId ? IMAGE_URL_PROD + response.localId : undefined,
      },    
      token: response.token,
    };
  };
  


const IMAGE_URL_PROD = 'https://meepblob.blob.core.windows.net/';
const IMAGE_URL_DEV = 'https://meepblobdev.blob.core.windows.net/';